import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Label,
  Input,
} from 'reactstrap';

import { userHasFeature } from '../../helpers/Features';
import { canUserManageShare } from '../../helpers/Share';
import { userIsAdmin, userIsManager } from '../../helpers/Auth';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

const ShareModalStatusChange = (({
  statusChange,
  handleClose,
  handleChangeStatusChange,
  statuses,
}) => {
  const intl = useIntl();

  return (
    <div className="share-status-change share-setting">
      <Label for="inpStatusChange" className={classnames('switch', { disabled: statuses.length === 0 || !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Enable statuses' })}
          <HelpIcon id="share-status-change">
            {intl.formatMessage({ defaultMessage: 'Allow recipients to change or add workspace statuses to files in this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-status-change" simple={true} />
          {statuses.length === 0 && (
            <HelpIcon id="share-status-change-disabled" permanent={true}>
              {intl.formatMessage({ defaultMessage: 'No file statuses created for this workspace' })}
            </HelpIcon>
          )}
          {userHasFeature('share-status-change') && (
            <div className="switch-control input-inner">
              <Input
                type="checkbox"
                name="status-change"
                id="inpStatusChange"
                disabled={statuses.length === 0 || !canUserManageShare()}
                value={true}
                checked={statusChange}
                onChange={handleChangeStatusChange}
              />
              <i />
            </div>
          )}
        </div>
      </Label>
      {((userIsAdmin() || userIsManager()) && statuses.length === 0) && (
        <div className="restricted-notice">
          {intl.formatMessage({ defaultMessage: 'Create file statuses in your <link>workspace settings</link>' }, {
            link: (msg) => (
              <Link to="/admin/settings/file-statuses" onClick={handleClose}>
                {msg}
              </Link>
            ),
          })}
        </div>
      )}
    </div>
  );
});

const mapStateToProps = state => ({
  statuses: state.Files.statuses,
});

ShareModalStatusChange.propTypes = {
  statusChange: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleChangeStatusChange: PropTypes.func.isRequired,
  statuses: PropTypes.array.isRequired,
};

export default connect(mapStateToProps)(ShareModalStatusChange);
